import { usePortals } from "react-portal-hook";

export const useModals = () => {
    return usePortals();
}